/* eslint-disable react/destructuring-assignment */
/* eslint-disable babel/camelcase */
/* eslint-disable react/prefer-stateless-function */
import { __ } from '@wordpress/i18n';
import { Component, Fragment } from 'react';

import { ToggleControl } from '@wordpress/components';

import Text from 'Components/Text';
import Label from 'Components/Label';
import ThemeSelect, { themeOptions } from 'Components/ThemeSelect';
import UserSelect, { userOptions } from 'Components/UserSelect';
import Select from 'Components/Select';

import {
	getCurrentSelected,
	handleTopLevelInput,
	toggleAttribute,
} from 'Utils/helpers';
import { formOptions } from 'Components/FormSelect';

const multiFormOptions = [
	{
		value: 'all',
		label: __('All Forms', 'ipt_fsqm'),
	},
	...formOptions,
];

const statOptions = [
	{
		value: 'daywise',
		label: __('Daywise Submission Breakdown', 'ipt_fsqm'),
	},
	{
		value: 'overall',
		label: __('Overall Submission Per Form', 'ipt_fsqm'),
	},
	{
		value: 'score',
		label: __('Score Breakdown', 'ipt_fsqm'),
	},
];

const graphTypes = [
	{
		value: 'pie',
		label: __('Pie Chart', 'ipt_fsqm'),
	},
	{
		value: 'doughnut',
		label: __('Doughnut Chart', 'ipt_fsqm'),
	},
];

function getFormArraySelectedValueFromString(value) {
	const forms = value.split(',');
	return multiFormOptions.filter(val => forms.includes(val.value));
}

function getFormStringFromArray(values) {
	return values.map(item => item.value).join(',');
}

class Stat extends Component {
	handleInput = e => {
		handleTopLevelInput(e, this.props.setAttributes);
	};

	render() {
		const { attributes, setAttributes } = this.props;
		const { stat_type } = attributes;

		return (
			<Fragment>
				<Label title={__('Statistics Type', 'ipt_fsqm')}>
					<Select
						value={getCurrentSelected(statOptions, stat_type)}
						options={statOptions}
						onChange={e => {
							setAttributes({ stat_type: e.value });
						}}
					/>
				</Label>
				<Label title={__('Select Forms', 'ipt_fsqm')}>
					<Select
						isMulti
						value={getFormArraySelectedValueFromString(
							attributes.form_ids
						)}
						onChange={e => {
							console.log(e);
							setAttributes({
								form_ids: getFormStringFromArray(e),
							});
						}}
						options={multiFormOptions}
					/>
				</Label>
				<Label title={__('Filter by user', 'ipt_fsqm')}>
					<Fragment>
						<ToggleControl
							checked={attributes.filter_for_user}
							onChange={() => {
								toggleAttribute(
									'filter_for_user',
									attributes,
									setAttributes
								);
							}}
							label={__('Filter stat by user', 'ipt_fsqm')}
							help={
								attributes.filter_for_user
									? __(
											'Stat will be filtered by the selected user for selected form',
											'ipt_fsqm'
									  )
									: __(
											'Stat will be generated for the selected forms',
											'ipt_fsqm'
									  )
							}
						/>
						{attributes.filter_for_user ? (
							<ToggleControl
								checked={attributes.show_login}
								onChange={() => {
									toggleAttribute(
										'show_login',
										attributes,
										setAttributes
									);
								}}
								label={__('Show login form', 'ipt_fsqm')}
								help={
									attributes.show_login
										? __(
												'If user is not already logged in, then show login form',
												'ipt_fsqm'
										  )
										: __(
												'Do not show anything if user is not logged in.',
												'ipt_fsqm'
										  )
								}
							/>
						) : null}
					</Fragment>
				</Label>
				{attributes.filter_for_user ? (
					<Fragment>
						<UserSelect
							value={getCurrentSelected(
								userOptions,
								attributes.user_id
							)}
							onChange={e => {
								setAttributes({ user_id: e.value });
							}}
						/>

						{attributes.show_login ? (
							<Fragment>
								<Label
									title={__('Login Form Heading', 'ipt_fsqm')}
								>
									<Text
										value={attributes.login_msg}
										onChange={this.handleInput}
										name="login_msg"
									/>
								</Label>
								<ThemeSelect
									value={getCurrentSelected(
										themeOptions,
										attributes.theme
									)}
									onChange={e => {
										setAttributes({ theme: e.value });
									}}
									title={__('Login Form Theme', 'ipt_fsqm')}
								/>
							</Fragment>
						) : null}
					</Fragment>
				) : null}
				<Label
					title={__(
						'Number of days or date since (YYYY/MM/DD)',
						'ipt_fsqm'
					)}
				>
					<Text
						value={attributes.days}
						onChange={this.handleInput}
						name="days"
					/>
				</Label>
				{stat_type === 'overall' || stat_type === 'daywise' ? (
					<Fragment>
						<Label
							title={__(
								'Max forms in graph before grouping',
								'ipt_fsqm'
							)}
						>
							<Text
								value={attributes.max}
								onChange={this.handleInput}
								name="max"
							/>
						</Label>
						<Label title={__('Grouping Label', 'ipt_fsqm')}>
							<Text
								value={attributes.others}
								onChange={this.handleInput}
								name="others"
							/>
						</Label>
					</Fragment>
				) : null}
				{stat_type === 'score' ? (
					<Label title={__('Graph Legend Format', 'ipt_fsqm')}>
						<Text
							value={attributes.label}
							onChange={this.handleInput}
							name="label"
						/>
					</Label>
				) : null}
				{stat_type === 'daywise' ? (
					<Fragment>
						<Label title={__('X Axis Label', 'ipt_fsqm')}>
							<Text
								value={attributes.xlabel}
								onChange={this.handleInput}
								name="xlabel"
							/>
						</Label>
						<Label title={__('Y Axis Label', 'ipt_fsqm')}>
							<Text
								value={attributes.ylabel}
								onChange={this.handleInput}
								name="ylabel"
							/>
						</Label>
						<Label title={__('Total Line Label', 'ipt_fsqm')}>
							<Text
								value={attributes.totalline}
								onChange={this.handleInput}
								name="totalline"
							/>
						</Label>
					</Fragment>
				) : null}
				{stat_type === 'overall' || stat_type === 'score' ? (
					<Label title={__('Chart Type', 'ipt_fsqm')}>
						<Select
							options={graphTypes}
							value={getCurrentSelected(
								graphTypes,
								attributes.type
							)}
							onChange={e => {
								setAttributes({ type: e.value });
							}}
						/>
					</Label>
				) : null}
				<Label title={__('Graph Height (px)', 'ipt_fsqm')}>
					<Text
						value={attributes.height}
						onChange={this.handleInput}
						name="height"
					/>
				</Label>
				<Label title={__('Graph Width (px)', 'ipt_fsqm')}>
					<Text
						value={attributes.width}
						onChange={this.handleInput}
						name="width"
					/>
				</Label>
			</Fragment>
		);
	}
}

export default Stat;
